import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeRegimesParams } from './service';

export enum HomeRegimesActions {
  Failure = '[Catalogs HomeRegimes] Failure',
  Request = '[Catalogs HomeRegimes] Request',
  Success = '[Catalogs HomeRegimes] Success',
}

export const HomeRegimesFailure = createAction(HomeRegimesActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeRegimesRequest = createAction(HomeRegimesActions.Request, props<{ parameters?: HomeRegimesParams }>());

export const HomeRegimesSuccess = createAction(HomeRegimesActions.Success, props<{ data: ParameterResult[] }>());
